import Plyr from 'plyr';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css'

const PIN_IMAGE_ID = 'MAPPIN'
const PIN_IMAGE_SELECTED_ID = 'MAPPIN-Selected'

class Mapbox extends HTMLElement {
  constructor() {
    super()
    mapboxgl.accessToken = 'pk.eyJ1IjoicmlzaGktYWRtaW4iLCJhIjoiY2xueWpxcXpwMHI3ZDJqcWtzbHlsbjUwbiJ9.PTLuxcgslTEppBQVgcXHtg';
    this.map = new mapboxgl.Map({
      container: this, // container ID
      style: 'mapbox://styles/rishi-admin/clnxwtwvr007p01qx5qur0mr6', // style URL
      dragRotate: false,
      touchZoomRotate: true,
      pitchWithRotate: true,
      dragPan: true,
      doubleClickZoom: true,
      scrollZoom: true,
      zoom: 1.5,
    });

    Alpine.store('mapPopup').map = this

    this.map.on('mousemove', 'origins', (event) => {
      this.map.getCanvas().style.cursor = 'pointer'

      if (event.features[0].properties.title || event.features[0].properties.producer_name) {
        Alpine.store('mapPopup').openHoverPopup({
          title: this.extractProperty(event.features[0].properties, 'title'),
          content: this.extractProperty(event.features[0].properties, 'producer_name'),
          left: event.point.x + 10,
          top: event.point.y + 10,
        })
      } else {
        Alpine.store('mapPopup').closeHoverPopup()
      }
    })

    this.map.on('click', 'origins', (event) => {
      if (event.features[0].properties.metaobject) {
        Alpine.store('mapPopup').mapTouched = true
        this.highlightOrigin(event.features[0].properties.metaobject, event.features[0].geometry.coordinates)

        Alpine.store('mapPopup').openPopup(
          event.features[0].properties.metaobject,
          event.features[0].geometry.coordinates,
          {
            title: event.features[0].properties.title,
            content: event.features[0].properties.producer_name,
            left: event.point.x + 10,
            top: event.point.y + 10,
          }
        )
      } else {
        Alpine.store('mapPopup').closePopup()
      }
    })


    this.map.on('mousemove', 'origins-labels', (event) => {
      this.map.getCanvas().style.cursor = 'pointer'
    })

    this.map.on('click', 'origins-labels', (event) => {
      Alpine.store('mapPopup').mapTouched = true
      Alpine.store('mapPopup').closePopup()

      this.map.flyTo({
        center: event.features[0].geometry.coordinates,
        zoom: 4
      })
    })


    this.map.on('mouseleave', 'origins', () => {
      this.map.getCanvas().style.cursor = '';
      Alpine.store('mapPopup').closeHoverPopup()
    })
    this.map.on('mouseleave', 'origins-labels', () => {
      this.map.getCanvas().style.cursor = '';
    })


    this.map.on('dragstart', () => {
      Alpine.store('mapPopup').mapTouched = true
    })
    this.map.on('wheel', () => {
      Alpine.store('mapPopup').mapTouched = true
    })
  }

  onPopupClosed() {
    this.map.setLayoutProperty('origins', 'icon-image', PIN_IMAGE_ID)
  }


  highlightOrigin(metaobject, coordinates) {
    this.map.setLayoutProperty('origins', 'icon-image',
      [
        'match',
        ['get', 'metaobject'],
        metaobject, PIN_IMAGE_SELECTED_ID, //image when id is the hovered feature id
        PIN_IMAGE_ID // default
      ]
    )

    const mapWidth = this.map.getBounds()._ne.lng - this.map.getBounds()._sw.lng
    const mapHeight = this.map.getBounds()._ne.lat - this.map.getBounds()._sw.lat

    if (window.innerWidth < 768) {
      this.map.flyTo({
        center: [
          coordinates[0],
          coordinates[1] - mapHeight / 4,
        ],
      })
    } else {
      this.map.flyTo({
        center: [
          coordinates[0] - mapWidth / 4,
          coordinates[1],
        ],
      })
    }
  }

  extractProperty(properties, searchKey) {
    let foundValue = undefined

    for (let key in properties) {
      const processedKey = key.replace(/[^a-zA-Z_]/g, '');
      if (processedKey == searchKey) {
        foundValue = properties[key]
        break
      }
    }

    return foundValue
  }
}

if (!customElements.get("mapbox-element"))
  customElements.define("mapbox-element", Mapbox)
